import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment/moment';
import { appointmentActions } from 'store';
import { CreateChancel } from 'components';
import { FindLoad, formatAMPM, useModal } from 'utils';
import { scheduleModalsStyle } from '../styles';

const ACTION_TYPE = 'CREATE_APPOINTMENT';
export const StaffOverlapping = ({ overlappingList, apptInfo }) => {
    const dispatch = useDispatch();
    const classes = scheduleModalsStyle();
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const apptDate = { ...apptInfo };
    apptDate.staffs = apptDate?.staffs?.filter((staff) => !overlappingList?.data?.some((overlap) => overlap?.staffId === staff));
    const handleSubmit = () => {
        dispatch(appointmentActions.createAppointment(apptDate));
    };

    return (
        <div className={classes.lockUnlockWrapper}>
            <p className={classes.confirmTitle} style={{ marginBottom: 12 }}>
                Confirmation
            </p>
            <p className={classes.confirmSubTitle} style={{ margin: 0 }}>
                {`Cannot create the following appointments due to overlapping schedules.`}
            </p>

            {!!overlappingList?.data?.length && (
                <div className={classes.confirmModalWornBox} style={{ margin: '24px 0 32px' }}>
                    {/*<p style={{lineHeight:'22px'}}>{`Cannot create the following appointments due to overlapping schedules.`}</p>*/}
                    <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                        {overlappingList?.data?.map((i, j) => (
                            <div key={j} style={{ marginBottom: 6 }}>
                                <p style={{ fontWeight: 600 }}>{`${i?.staffName}`}</p>
                                <p style={{ fontWeight: 400 }}>
                                    {`${i?.displayID} - ${moment.utc(i?.date).format('MM/DD/YYYY')} (${formatAMPM(i?.startTime)} - ${formatAMPM(i?.endTime)})`}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <CreateChancel
                disabled={loader?.length || apptDate?.staffs?.length === 0}
                loader={!!loader?.length}
                create={'Confirm'}
                chancel={'Cancel'}
                onCreate={handleSubmit}
                onClose={() => close()}
                buttonWidth="223px"
                createButnMargin={'16px'}
            />
        </div>
    );
};
